export const UPDATE_SPOT_FAILURE = 'UPDATE_SPOT_FAILURE';

export const updateSpotFailure = (payload: Error) => ({
    type: UPDATE_SPOT_FAILURE,
    payload,
    error: true,
});
